module.exports = __webpack_public_path__ + "img/window-contact-sm.6046af43.svg";